export default "__VITE_ASSET__8k9i02LC__"